import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Gstr1Layer from "../components/Gstr1Layer";

const Gstr1Page = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="GSTR-1 Report" />
        <Gstr1Layer />
      </MasterLayout>
    </>
  );
};

export default Gstr1Page;
